/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ tool: NonNullable<unknown> }} Options_Cli_Selected_Path_LabelInputs */

const en_options_cli_selected_path_label = /** @type {(inputs: Options_Cli_Selected_Path_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Selected ${i?.tool} path`)
};

const fr_options_cli_selected_path_label = /** @type {(inputs: Options_Cli_Selected_Path_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Chemin sélectionné pour ${i?.tool}`)
};

const de_options_cli_selected_path_label = /** @type {(inputs: Options_Cli_Selected_Path_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ausgewählter Pfad ${i?.tool}`)
};

const it_options_cli_selected_path_label = /** @type {(inputs: Options_Cli_Selected_Path_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Percorso selezionato ${i?.tool}`)
};

const ru_options_cli_selected_path_label = /** @type {(inputs: Options_Cli_Selected_Path_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Выбранный путь ${i?.tool}`)
};

const es_options_cli_selected_path_label = /** @type {(inputs: Options_Cli_Selected_Path_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ruta ${i?.tool} seleccionada`)
};

const zh_cn2_options_cli_selected_path_label = /** @type {(inputs: Options_Cli_Selected_Path_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`已选择 ${i?.tool} 路径`)
};

const ja_options_cli_selected_path_label = /** @type {(inputs: Options_Cli_Selected_Path_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`選択された${i?.tool}パス`)
};

const hi_options_cli_selected_path_label = /** @type {(inputs: Options_Cli_Selected_Path_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`चयनित ${i?.tool} पथ`)
};

const pt_pt2_options_cli_selected_path_label = /** @type {(inputs: Options_Cli_Selected_Path_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Caminho ${i?.tool} selecionado`)
};

/**
* | output |
* | --- |
* | "Selected {tool} path" |
*
* @param {Options_Cli_Selected_Path_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_cli_selected_path_label = /** @type {((inputs: Options_Cli_Selected_Path_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Cli_Selected_Path_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_cli_selected_path_label(inputs)
	if (locale === "de") return de_options_cli_selected_path_label(inputs)
	if (locale === "it") return it_options_cli_selected_path_label(inputs)
	if (locale === "ru") return ru_options_cli_selected_path_label(inputs)
	if (locale === "es") return es_options_cli_selected_path_label(inputs)
	if (locale === "zh-CN") return zh_cn2_options_cli_selected_path_label(inputs)
	if (locale === "ja") return ja_options_cli_selected_path_label(inputs)
	if (locale === "hi") return hi_options_cli_selected_path_label(inputs)
	if (locale === "pt-PT") return pt_pt2_options_cli_selected_path_label(inputs)
	return en_options_cli_selected_path_label(inputs)
});